import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth/auth.service';
import { TelecomService } from 'src/app/services/telecom/telecom.service';
import { TimeService } from 'src/app/services/time/time.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-overflow-upload',
  templateUrl: './overflow-upload.component.html',
  styleUrls: ['./overflow-upload.component.css']
})
export class OverflowUploadComponent implements OnInit {
  //batch upload
  batchData: Array<any> = [];
  filteredData: Array<any> = [];
  historicBatches: Array<any> = [];

  //file
  selectedFile: File = null;
  fileName: string = "";
  batchDescription: string = "";
  csvData: Array<string> = [];

  //header
  inputItemsPerPage: number = 10;
  itemsPerPage: number = 10;
  showAll: boolean = true;
  searchString: string = "";
  successCount: number = 0;
  errorCount: number = 0;

  //page
  lambdaError: boolean = false;
  lambdaMessage: string = '';
  username: string = '';
  batchSelect: any = ""
  batchIsSelected: boolean = false;
  disableProcessBatch: boolean = true;
  disableLoadFile: boolean = true;

  constructor(private telecomService: TelecomService, private auth: AuthService, private timeService: TimeService) { }

  ngOnInit() {
    let identity = this.auth.userPool.getCurrentUser().username;
    if (identity.split("_").length === 2) {
      this.username = identity.split('_')[1];
    } else {
      this.username = identity;
    }
    console.log(this.username);
    this.getBatchIds();
  }

  uploadFile($event) {
    this.disableLoadFile = false;
    let csv: string = ""
    this.selectedFile = $event.target.files[0];
    this.fileName = this.selectedFile.name;
    console.log('name: ', this.selectedFile.name);
    console.log('size: ', this.selectedFile.size);
    console.log('type: ', this.selectedFile.type);
    let reader: FileReader = new FileReader();
    reader.readAsText(this.selectedFile);
    reader.onload = (e) => {
      console.log('e: ', e);
      csv = reader.result as string;
      let rows = csv.split('\n');
      for (let x = 0; x < rows.length; x++) {
        if (rows[x].split(',').join('').trim() == '') {
          rows.splice(x, 1);
          x--;
        }
      }
      if (rows[rows.length - 1] === "") {
        rows.pop();
      }
      console.log('rows: ', rows);
      this.csvData = rows;
      this.batchDescription = "";
    }
  }

  /**processes csv and sends it to be stored as a batch in batch table */
  submitCsvData() {
    this.lambdaError = false;
    this.lambdaMessage = '';
    this.batchData = [];

    let params = {
      FunctionName: environment.AgentOverflowRecordLambdaName,
      Payload: JSON.stringify({
        operation: "put",
        csvData: this.csvData,
        batchName: this.buildBatchName()
      })
    };
    this.telecomService.callLambda(params, "An error occurred while processing the user data").then(
      (response: any) => {
        if (response.statusCode == 200) {
          this.batchSelect = response.body;
          this.getBatchIds();
          this.getBatch(this.batchSelect);
        }
      },
      err => {
        this.lambdaError = true;
        this.lambdaMessage = "An error occurred while creating batch record"
      }
    );
  }

  /**returns a selected batch to be displayed in the UI */
  getBatch(batchId: string) {
    this.lambdaError = false;
    this.lambdaMessage = '';
    this.batchData = [];

    let params = {
      FunctionName: environment.AgentOverflowRecordLambdaName,
      Payload: JSON.stringify({
        operation: "get",
        "batchId": batchId
      })
    };
    this.telecomService.callLambda(params, "Failed to retrieve the specified batch").then(
      (response: any) => {
        if (response.statusCode == 200) {
          this.batchData = response.body
          this.disableProcessBatch = false;
          this.applyFilter();
          this.statusCount();
        } else {
          this.lambdaError = true;
          this.lambdaMessage = "Failed to retrieve the specified batch"
        }
      }, err => {
        this.lambdaError = true;
        this.lambdaMessage = "Failed to retrieve the specified batch"
      }
    );
  }

  /**returns batchIds and batchNames so user can select batch to be retrieved and displayed */
  getBatchIds() {
    this.lambdaError = false;
    this.lambdaMessage = '';
    this.historicBatches = [];

    let params = {
      FunctionName: environment.GetOverflowBatchIdLambdaName,
      Payload: JSON.stringify({})
    };
    this.telecomService.callLambda(params, "An error occurred while processing the user data").then(
      (response: any) => {
        if (response.statusCode == 200) {
          this.historicBatches = response.body
        } else {
          this.lambdaError = true;
          this.lambdaMessage = "Failed to retrieve historic batches"
        }
      }, err => {
        this.lambdaError = true;
        this.lambdaMessage = "Failed to retrieve historic batches"
      }
    );
  }

  /**selected batch will be processed and rows will be added to overflow table */
  processBatch() {
    this.lambdaError = false;
    this.lambdaMessage = '';
    this.disableProcessBatch = true;
    let batchId = this.batchSelect
    let params = {
      FunctionName: environment.AgentOverflowBatchLambdaName,
      Payload: JSON.stringify({ "batchId": batchId })
    };
    this.telecomService.callLambda(params, "An error occurred while processing overflow batch").then((response: any) => {
      this.disableProcessBatch = false;
      this.getBatch(batchId)
      if (response.statusCode != 200) {
        this.lambdaError = true;
        this.lambdaMessage = "An error occurred while processing overflow batch"
      }
    },
      err => {
        this.getBatch(batchId);
        this.lambdaError = true;
        this.lambdaMessage = "An error occurred while processing overflow batch"
      });
  }

  applyFilter() {
    let temp = []
    let search = this.searchString.toLowerCase();
    this.batchData.map(x => {
      if (x.username.toLowerCase().includes(search) ||
        x.overflowQueueName.toLowerCase().includes(search) ||
        x.lob.toLowerCase().includes(search)
      ) {
        if (this.showAll) {
          temp.push(x);
        } else if (x.status != 'success') {
          temp.push(x);
        }
      }
    });
    this.filteredData = JSON.parse(JSON.stringify(temp));
  }

  statusCount() {
    this.successCount = 0;
    this.errorCount = 0;
    this.batchData.map(x => {
      if (x.status == 'success') {
        this.successCount++;
      } else if (x.status == 'failed') {
        this.errorCount++;
      }
    });
    if (this.errorCount > 0) {
      this.lambdaError = true;
      this.lambdaMessage = "Errors in batch. Review table for details."
    }
  }

  buildBatchName() {
    let timeStamp = this.timeService.newTimeStamp();
    let batchName = this.username + timeStamp;
    console.log("batch name: ", batchName);
    return batchName;
  }

  cancelSelectedBatch() {
    this.batchData = [];
    this.disableProcessBatch = true;
  }

  enforceMaxNumber() {
    if (this.itemsPerPage == null) {
      this.inputItemsPerPage = 1;
    } else {
      if (this.itemsPerPage > 200) {
        this.itemsPerPage = 200;
      } else if (this.itemsPerPage < 1) {
        this.itemsPerPage = 1
      }
      this.inputItemsPerPage = this.itemsPerPage;
    }
  }

  cleanField() {
    if (this.itemsPerPage == null) {
      this.itemsPerPage = 1;
    }
    this.enforceMaxNumber();
  }

}
